import { makeAutoObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
import localForage from "localforage";
import Axios from 'axios';

export default class FavoriteStore {
    items = [];
    total = 0;

    constructor() {
        makeAutoObservable(this);
        makePersistable(this, {
            name: 'FavoriteStore',
            properties: ['items', 'total'],
            storage: localForage
        });

        this.getItems();
    }

    getItems() {
        return this.items;
    }

    validateItems(url) {
        const uuids = [];
        this.items.forEach((item) => {
            uuids.push(item.id);
        });

        this.total = 0;

        Axios.get(url, {
            params: {
                uuids: uuids,
            }
        }).then((result) => {
            this.items.forEach((item) => {
                item['available'] = result.data[item.id].available;
            });

            this.total = this.items.length;
        });
    }

    toggleItem(item) {
        const index = this.items.findIndex((favorite) => favorite.id === item.id);
        if (index === -1) {
            this.items.push(item);
        } else {
            this.items.splice(index, 1);
        }

        this.total = this.items.length;
    }
}
